export const MOBILE_PADDING = 30
export const PADDING_X = 50
export const PADDING_TOP = 64
